import type { ToolActivity } from "../tool-activity";
import { toolActivityBasename } from "../tool-activity-basename";
import { toolInput } from "../tool-input";
import type { ToolActivityState } from "../tool-activity-state";
import { captureLabel } from "./capture-label";
import { CAPTURE_LABEL_MAX } from "./capture-label-constants";

export function describeAttachImage(
  record: Record<string, unknown>,
  state: ToolActivityState,
): ToolActivity {
  const file = toolActivityBasename(toolInput.str(record.path));
  return captureLabel(
    {
      optionFailed: "Failed to attach a silent image",
      optionRunning: "Attaching a silent image",
      optionDone: "Attached a silent image",
      failed: (subject) =>
        subject ? `Failed to attach ${subject}` : "Failed to attach an image",
      running: (subject) =>
        subject ? `Attaching ${subject}` : "Attaching an image",
      done: (subject) =>
        subject ? `Attached ${subject}` : "Attached an image",
    },
    state,
    {
      isOption: record.silent === true,
      subject: file ? toolInput.truncate(file, CAPTURE_LABEL_MAX) : null,
    },
  );
}
